import { Table } from "@/pages/a7/Table";
import {
  type A7FIAInstrument,
  columnVisibilityInit,
  getInstrumentsColumns,
} from "./columns";
import { FilterA7FIAInstruments, filterA7FIAInstrumentsSchema } from "./filter";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const table_name = "a7_fia_instruments";

export const A7FIAInstrumentsTable = () => {
  const { t, i18n } = useTranslation(["tables", "common"]);
  const columns = useMemo(() => getInstrumentsColumns(t), [t, i18n.language]);

  return (
    <Table<A7FIAInstrument, typeof filterA7FIAInstrumentsSchema>
      label={t(`${table_name}.title`, {
        ns: "tables",
        defaultValue: "Financial instruments",
      })}
      client="a7"
      table_name={table_name}
      columns={columns}
      filter={<FilterA7FIAInstruments />}
      columnVisibilityInit={columnVisibilityInit}
    />
  );
};
